export default "__VITE_ASSET__CfKH0_z3__"